import type { WorkflowRunPayload } from '@Application/WorkflowRuns/WorkflowRun/Actions/workflowRunFetched';

/** The retry answers with the run entire, so the screen refreshes without a second round-trip. */
export type WorkflowStepRetriedAction = {
	type: 'WORKFLOW_STEP_RETRIED';
	payload: WorkflowRunPayload;
	facilityId: number;
	typeKey: string;
	subjectId: number;
};

export default (
	payload: WorkflowRunPayload,
	facilityId: number,
	typeKey: string,
	subjectId: number,
): WorkflowStepRetriedAction => ({
	type: 'WORKFLOW_STEP_RETRIED',
	payload,
	facilityId,
	typeKey,
	subjectId,
});
